import React, { useEffect, useState } from "react";
import { toCurrency } from "../utils/Convert";
import axios from "axios";
import { api } from "../utils/Api";
import TaxPicker from "../invoice/TaxPicker";
import {
	Col,
	Form,
	Input,
	InputNumber,
	Row,
	DatePicker,
	Select,
	Button,
	Typography,
	Flex,
	Statistic,
	notification,
} from "antd";
import dayjs from "dayjs";
import { CustomTable } from "../utils/CustomComponents";
import { DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

const optionsPaymentType = [
	{ value: "Cash", label: "Cash" },
	{ value: "Check", label: "Check" },
	{ value: "Card", label: "Credit Card" },
	{ value: "Wire", label: "Wire" },
];

const PaymentJob2 = ({ jobId, pcb }) => {
	const [total, setTotal] = useState(0);
	const [material, setMaterial] = useState(0);
	const [taxAmount, setTaxAmount] = useState(0);
	const [sumPayment, setSumPayments] = useState(0);
	const [deposit, setDeposit] = useState(0);
	const [deliveryFee, setDeliveryFee] = useState(0);
	const [fuelSurcharge, setFuelSurcharge] = useState(0);
	const [balance, setBalance] = useState(0);
	const [payments, setPayments] = useState([]);
	const [first, setFirst] = useState(true);
	const [job, setJob] = useState({});
	const [invoice, setInvoice] = useState("");
	const [invoiceTax, setInvoiceTax] = useState({
		label: "State",
		value: "state",
	});
	const [colorTicket, setColorTicket] = useState(0);
	const [fiberBags, setFiberBags] = useState(0);
	const [sizeBags, setSizeBags] = useState(0);
	const [miscelaneosFee, setMiscelaneosFee] = useState(0);
	const [energyConsumptionFee, setEnergyConsumptionFee] = useState(0);
	const [timeSurchargeFee, setTimeSurchargeFee] = useState(0);
	const [lightSurchargeFee, setLightSurchargeFee] = useState(0);
	const [iceSurchargeFee, setIceSurchargeFee] = useState(0);
	const [readyMixTruckRentalServiceFee, setReadyMixTruckRentalServiceFee] =
		useState(0);
	const [readyMixDriverFee, setReadyMixDriverFee] = useState(0);
	const [plantStandByFee, setPlantStandByFee] = useState(0);
	const [environmentalChargePerLoadFee, setEnvironmentalChargePerLoadFee] =
		useState(0);
	const [unitPrice, setUnitPrice] = useState(0);

	const [form] = Form.useForm();
	const [paymentType, setPaymentType] = useState(undefined);
	const [initialValues, setInitialValues] = useState({
		date: dayjs(),
	});
	const [loadingTable, setLoadingTable] = useState(true);
	const [subtotal, setSubtotal] = useState(0);
	const [creditCardFee, setCreditCardFee] = useState(0);
	const [discountAmount, setDiscountAmount] = useState(0);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			getPayments();
			if (first) {
				getJobInfo();
				setFirst(false);
			}
		}, 1000);
		return () => clearTimeout(timer);
	}, []);

	const getPayments = async () => {
		const url = api + "/payment/get/" + jobId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				setPayments(
					data.payload.map((payment) => ({
						key: payment._id,
						id: payment._id,
						date: dayjs(payment.at).format("MM/DD/YYYY hh:mm:ss A"),
						paymentNumber: payment.paymentNumber,
						amount: payment.amount,
						reference: payment.reference || "N/A",
						transactionNumber: payment.transactionNumber || "N/A",
						comments: payment.comments || "N/A",
						user: payment.createdBy ? payment.createdBy.name : "N/A",
					})),
				);
				const sumaPago = data.payload.reduce(
					(acc, pago) => acc + pago.amount,
					0,
				);
				setSumPayments(sumaPago);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoadingTable(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get payments");
			console.error(err.message);
			return null;
		}
	};

	const updateBalance = async (formData) => {
		// Current Payments total
		const totalSumPayment = sumPayment + parseFloat(formData.amount);
		//All due of invoice
		const totalAmountOfInvoice = total;
		//New balance
		const newBalance =
			totalAmountOfInvoice - totalSumPayment <= 0
				? 0
				: totalAmountOfInvoice - totalSumPayment;
		setDeposit(totalSumPayment);
		setBalance(newBalance);

		const jobChanges = {
			deposit: totalSumPayment,
			pendingBalance: newBalance,
			paid: newBalance === 0 ? true : false,
			paidTime: newBalance === 0 ? dayjs().toDate() : null,
		};

		await updateJob(jobChanges);

		const invoiceChanges = {
			deposit: totalSumPayment,
			balance: newBalance,
			invoiceStatus: newBalance === 0 ? "paid" : "partial",
			paymentTotalReceived: totalSumPayment,
		};

		await updateInvoice(invoiceChanges);
	};

	const updateBalanceOnDelete = async (formData) => {
		//Total after payment is deleted
		const sumPaymentsTotal = sumPayment - parseFloat(formData.amount);

		const newBalance = balance + formData.amount;
		setDeposit(sumPaymentsTotal);
		setBalance(newBalance);

		const jobChanges = {
			deposit: sumPaymentsTotal,
			pendingBalance: newBalance,
			paid: false,
			paidTime: null,
		};

		await updateJob(jobChanges);

		const invoiceChanges = {
			deposit: sumPaymentsTotal,
			balance: newBalance,
			invoiceStatus: "partial",
			paymentTotalReceived: sumPaymentsTotal,
		};

		await updateInvoice(invoiceChanges);
	};

	const addPayment = async (formData) => {
		const url = api + "/payment/create";
		try {
			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				await getPayments();
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", "Error while trying to add payment");
			console.error(err.message);
			return null;
		}
	};

	const deletePayment = async (id) => {
		const url = api + `/payment/delete/${id}`;
		try {
			const { data } = await axios.delete(url);
			if (data.success) {
				openNotification("success", "Success", data.message);
				await getPayments();
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Error while trying to delete payment",
			);
			console.error(err.message);
			return null;
		}
	};

	const updateJob = async (formData) => {
		const url = api + "/job/" + job._id;

		try {
			const { data } = await axios.patch(url, formData);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to update job");
			console.error(err.message);
			return null;
		}
	};

	const updateInvoice = async (formData) => {
		const url = api + "/invoice/" + invoice._id;

		try {
			const { data } = await axios.patch(url, formData);
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Error while trying to update invoice",
			);
			console.error(err.message);
			return null;
		}
	};

	const getJobInfo = async () => {
		const urlJob = api + "/job/" + jobId;
		const urlInvoice = api + "/jobinvoice/" + jobId;
		const urlCompanyInfo = api + "/company";
		const urlLoad = api + "/load/" + jobId;

		const reqJob = await axios.get(urlJob);
		const reqInvoice = await axios.get(urlInvoice);
		const reqCompany = await axios.get(urlCompanyInfo);
		const reqLoads = await axios.get(urlLoad);

		axios.all([reqJob, reqInvoice, reqCompany, reqLoads]).then(
			axios.spread((...responses) => {
				const jobData = responses[0].data;
				const invoiceData = responses[1].data;
				const companyData = responses[2].data;
				const loadData = responses[3].data;

				setJob(jobData);
				setInvoice(invoiceData);
				calculateTotal(jobData, invoiceData, companyData, loadData);
			}),
		);
	};

	const calculateTotal = (job, invoice, companyInfo, loads) => {
		//Get tax
		let taxPercentaje = 0;
		switch (invoice.invoiceTax) {
			case "state":
				taxPercentaje =
					job.franchise === "Castle" ? 0.0825 : companyInfo.stateTax;
				setInvoiceTax({ value: "state", label: "State" });
				break;
			case "county":
				taxPercentaje =
					job.franchise === "Castle" ? 0.0825 : companyInfo.countyTax;
				setInvoiceTax({ value: "county", label: "County" });
				break;
			case "exempt":
				setInvoiceTax({ value: "exempt", label: "Exempt" });
				taxPercentaje = 0;
				break;
			default:
				taxPercentaje = companyInfo.stateTax;
				setInvoiceTax({ value: "state", label: "State" });
		}

		const totalLoadYards = loads.reduce((acc, load) => acc + load.yards, 0);
		const materialAmount = totalLoadYards * job.unitPrice;
		setMaterial(materialAmount);
		const trips = loads.length;
		setUnitPrice(job.unitPrice);

		let subtotal = materialAmount;

		if (invoice.isTotal) {
			//Values of extras
			const fuelRate = invoice.fuelRate || 0;
			const timeSurchargeFee = invoice.timeSurchargeFee || 0;
			const lightSurchargeFee = invoice.lightSurchargeFee || 0;
			const iceSurchargeFee = invoice.iceSurchargeFee || 0;
			const readyMixTruckRentalServiceFee =
				invoice.readyMixTruckRentalServiceFee || 0;
			const readyMixDriverFee = invoice.readyMixDriverFee || 0;
			const plantStandByFee = invoice.plantStandByFee || 0;
			const environmentalChargePerLoadFee =
				invoice.environmentalChargePerLoadFee || 0;
			const shippingFee = invoice.shippingFee || 0;
			const colorTicket = invoice.colorTicket || 0;
			const fiberBags = invoice.fiberBags || 0;
			const sizeBags = invoice.sizeBags || 0;
			const miscelaneosFee = invoice.miscelaneosFee || 0;
			const energyConsumptionFee = invoice.energyConsumptionFee || 0;

			//Values if is selected
			const fuelSurcharge = invoice.fuelSurcharge || false;
			const timeSurcharge = invoice.timeSurcharge || false;
			const lightSurcharge = invoice.lightSurcharge || false;
			const iceSurcharge = invoice.iceSurcharge || false;
			const readyMixTruckRentalService =
				invoice.readyMixTruckRentalService || false;
			const readyMixDriver = invoice.readyMixDriver || false;
			const plantStandBy = invoice.plantStandBy || false;
			const environmentalChargePerLoad =
				invoice.environmentalChargePerLoad || false;
			const shipping = invoice.shipping || false;
			const color = invoice.color || false;
			const fiber = invoice.fiber || false;
			const size = invoice.size || false;
			const miscelaneos = invoice.miscelaneos || false;
			const energyConsumption = invoice.energyConsumption || false;

			//Values if are global
			const fuelSurchargeGlobal = invoice.fuelSurchargeGlobal || false;
			const timeSurchargeGlobal = invoice.timeSurchargeGlobal || false;
			const lightSurchargeGlobal = invoice.lightSurchargeGlobal || false;
			const iceSurchargeGlobal = invoice.iceSurchargeGlobal || false;
			const readyMixTruckRentalServiceGlobal =
				invoice.readyMixTruckRentalServiceGlobal || false;
			const readyMixDriverGlobal = invoice.readyMixDriverGlobal || false;
			const plantStandByGlobal = invoice.plantStandByGlobal || false;
			const environmentalChargePerLoadGlobal =
				invoice.environmentalChargePerLoadGlobal || false;
			const shippingGlobal = invoice.shippingGlobal || false;
			const colorGlobal = invoice.colorGlobal || false;
			const fiberGlobal = invoice.fiberGlobal || false;
			const sizeGlobal = invoice.sizeGlobal || false;
			const miscelaneosGlobal = invoice.miscelaneosGlobal || false;
			const energyConsumptionGlobal = invoice.energyConsumptionGlobal || false;

			//Total values of extras
			let fuelRateTotal = 0;
			let timeSurchargeFeeTotal = 0;
			let lightSurchargeFeeTotal = 0;
			let iceSurchargeFeeTotal = 0;
			let readyMixTruckRentalServiceFeeTotal = 0;
			let readyMixDriverFeeTotal = 0;
			let plantStandByFeeTotal = 0;
			let environmentalChargePerLoadFeeTotal = 0;
			let shippingFeeTotal = 0;
			let colorTicketTotal = 0;
			let fiberBagsTotal = 0;
			let sizeBagsTotal = 0;
			let miscelaneosFeeTotal = 0;
			let energyConsumptionFeeTotal = 0;

			if (fuelSurcharge) {
				if (fuelSurchargeGlobal) {
					subtotal += fuelRate;
					fuelRateTotal = fuelRate;
				} else {
					subtotal += fuelRate * trips;
					fuelRateTotal = fuelRate * trips;
				}
			}
			if (shipping) {
				if (shippingGlobal) {
					subtotal += shippingFee;
					shippingFeeTotal = shippingFee;
				} else {
					subtotal += shippingFee * trips;
					shippingFeeTotal = shippingFee * trips;
				}
			}
			if (color) {
				if (colorGlobal) {
					subtotal += colorTicket;
					colorTicketTotal = colorTicket;
				} else {
					subtotal += colorTicket * trips;
					colorTicketTotal = colorTicket * trips;
				}
			}
			if (fiber) {
				if (fiberGlobal) {
					subtotal += fiberBags;
					fiberBagsTotal = fiberBags;
				} else {
					subtotal += fiberBags * trips;
					fiberBagsTotal = fiberBags * trips;
				}
			}
			if (size) {
				if (sizeGlobal) {
					subtotal += sizeBags;
					sizeBagsTotal = sizeBags;
				} else {
					subtotal += sizeBags * trips;
					sizeBagsTotal = sizeBags * trips;
				}
			}
			if (miscelaneos) {
				if (miscelaneosGlobal) {
					subtotal += miscelaneosFee;
					miscelaneosFeeTotal = miscelaneosFee;
				} else {
					subtotal += miscelaneosFee * trips;
					miscelaneosFeeTotal = miscelaneosFee * trips;
				}
			}
			if (energyConsumption) {
				if (energyConsumptionGlobal) {
					subtotal += energyConsumptionFee;
					energyConsumptionFeeTotal = energyConsumptionFee;
				} else {
					subtotal += energyConsumptionFee * trips;
					energyConsumptionFeeTotal = energyConsumptionFee * trips;
				}
			}
			if (timeSurcharge) {
				if (timeSurchargeGlobal) {
					subtotal += timeSurchargeFee;
					timeSurchargeFeeTotal = timeSurchargeFee;
				} else {
					subtotal += timeSurchargeFee * trips;
					timeSurchargeFeeTotal = timeSurchargeFee * trips;
				}
			}
			if (lightSurcharge) {
				if (lightSurchargeGlobal) {
					subtotal += lightSurchargeFee;
					lightSurchargeFeeTotal = lightSurchargeFee;
				} else {
					subtotal += lightSurchargeFee * trips;
					lightSurchargeFeeTotal = lightSurchargeFee * trips;
				}
			}
			if (iceSurcharge) {
				if (iceSurchargeGlobal) {
					subtotal += iceSurchargeFee;
					iceSurchargeFeeTotal = iceSurchargeFee;
				} else {
					subtotal += iceSurchargeFee * trips;
					iceSurchargeFeeTotal = iceSurchargeFee * trips;
				}
			}
			if (readyMixTruckRentalService) {
				if (readyMixTruckRentalServiceGlobal) {
					subtotal += readyMixTruckRentalServiceFee;
					readyMixTruckRentalServiceFeeTotal = readyMixTruckRentalServiceFee;
				} else {
					subtotal += readyMixTruckRentalServiceFee * trips;
					readyMixTruckRentalServiceFeeTotal =
						readyMixTruckRentalServiceFee * trips;
				}
			}
			if (readyMixDriver) {
				if (readyMixDriverGlobal) {
					subtotal += readyMixDriverFee;
					readyMixDriverFeeTotal = readyMixDriverFee;
				} else {
					subtotal += readyMixDriverFee * trips;
					readyMixDriverFeeTotal = readyMixDriverFee * trips;
				}
			}
			if (plantStandBy) {
				if (plantStandByGlobal) {
					subtotal += plantStandByFee;
					plantStandByFeeTotal = plantStandByFee;
				} else {
					subtotal += plantStandByFee * trips;
					plantStandByFeeTotal = plantStandByFee * trips;
				}
			}
			if (environmentalChargePerLoad) {
				if (environmentalChargePerLoadGlobal) {
					subtotal += environmentalChargePerLoadFee;
					environmentalChargePerLoadFeeTotal = environmentalChargePerLoadFee;
				} else {
					subtotal += environmentalChargePerLoadFee * trips;
					environmentalChargePerLoadFeeTotal =
						environmentalChargePerLoadFee * trips;
				}
			}

			if (invoice.isCreditCardPayment) {
				const cardFee = subtotal * (invoice.creditCardFee / 100);
				subtotal += cardFee;
				setCreditCardFee(cardFee);
			}

			setFuelSurcharge(fuelRateTotal);
			setTimeSurchargeFee(timeSurchargeFeeTotal);
			setDeliveryFee(shippingFeeTotal);
			setColorTicket(colorTicketTotal);
			setFiberBags(fiberBagsTotal);
			setSizeBags(sizeBagsTotal);
			setMiscelaneosFee(miscelaneosFeeTotal);
			setEnergyConsumptionFee(energyConsumptionFeeTotal);
			setTimeSurchargeFee(timeSurchargeFeeTotal);
			setLightSurchargeFee(lightSurchargeFeeTotal);
			setIceSurchargeFee(iceSurchargeFeeTotal);
			setReadyMixTruckRentalServiceFee(readyMixTruckRentalServiceFeeTotal);
			setReadyMixDriverFee(readyMixDriverFeeTotal);
			setPlantStandByFee(plantStandByFeeTotal);
			setEnvironmentalChargePerLoadFee(environmentalChargePerLoadFeeTotal);
		} else {
			//Total values of extras
			let fuelRateTotal = 0;
			let timeSurchargeFeeTotal = 0;
			let lightSurchargeFeeTotal = 0;
			let iceSurchargeFeeTotal = 0;
			let readyMixTruckRentalServiceFeeTotal = 0;
			let readyMixDriverFeeTotal = 0;
			let plantStandByFeeTotal = 0;
			let environmentalChargePerLoadFeeTotal = 0;
			let shippingFeeTotal = 0;
			let colorTicketTotal = 0;
			let fiberBagsTotal = 0;
			let sizeBagsTotal = 0;
			let miscelaneosFeeTotal = 0;
			let energyConsumptionFeeTotal = 0;

			loads.map((load) => {
				if (load.fuelSurcharge) fuelRateTotal += load.fuelRate;
				if (load.shipping) shippingFeeTotal += load.shippingFee;
				if (load.color) colorTicketTotal += load.colorTicket * 50;
				if (load.fiber) fiberBagsTotal += load.fiberBags * 20;
				if (load.size) sizeBagsTotal += load.sizeBags * 20;
				if (load.miscelaneos) miscelaneosFeeTotal += load.miscelaneosFee;
				if (load.energyConsumption)
					energyConsumptionFeeTotal += load.energyConsumptionFee;
				if (load.timeSurcharge) timeSurchargeFeeTotal += load.timeSurchargeFee;
				if (load.lightSurcharge)
					lightSurchargeFeeTotal += load.lightSurchargeFee;
				if (load.iceSurcharge) iceSurchargeFeeTotal += load.iceSurchargeFee;
				if (load.readyMixTruckRentalService)
					readyMixTruckRentalServiceFeeTotal +=
						load.readyMixTruckRentalServiceFee;
				if (load.readyMixDriver)
					readyMixDriverFeeTotal += load.readyMixDriverFee;
				if (load.plantStandBy) plantStandByFeeTotal += load.plantStandByFee;
				if (load.environmentalChargePerLoad)
					environmentalChargePerLoadFeeTotal +=
						load.environmentalChargePerLoadFee;
			});

			subtotal +=
				fuelRateTotal +
				timeSurchargeFeeTotal +
				lightSurchargeFeeTotal +
				iceSurchargeFeeTotal +
				readyMixTruckRentalServiceFeeTotal +
				readyMixDriverFeeTotal +
				plantStandByFeeTotal +
				environmentalChargePerLoadFeeTotal +
				shippingFeeTotal +
				colorTicketTotal +
				fiberBagsTotal +
				sizeBagsTotal +
				miscelaneosFeeTotal +
				energyConsumptionFeeTotal;

			setFuelSurcharge(fuelRateTotal);
			setTimeSurchargeFee(timeSurchargeFeeTotal);
			setDeliveryFee(shippingFeeTotal);
			setColorTicket(colorTicketTotal);
			setFiberBags(fiberBagsTotal);
			setSizeBags(sizeBagsTotal);
			setMiscelaneosFee(miscelaneosFeeTotal);
			setEnergyConsumptionFee(energyConsumptionFeeTotal);
			setTimeSurchargeFee(timeSurchargeFeeTotal);
			setLightSurchargeFee(lightSurchargeFeeTotal);
			setIceSurchargeFee(iceSurchargeFeeTotal);
			setReadyMixTruckRentalServiceFee(readyMixTruckRentalServiceFeeTotal);
			setReadyMixDriverFee(readyMixDriverFeeTotal);
			setPlantStandByFee(plantStandByFeeTotal);
			setEnvironmentalChargePerLoadFee(environmentalChargePerLoadFeeTotal);
		}

		setSubtotal(subtotal);

		let taxes = 0;
		let total = 0;

		if (invoice.isDiscount) {
			if (invoice.discountType === "percentageAfter") {
				taxes = subtotal * taxPercentaje;
				total = subtotal + taxes;
				let descuento =
					parseFloat(total) * (parseFloat(invoice.discount) / 100.0);
				total -= descuento;
				setDiscountAmount(descuento);
			} else if (invoice.discountType === "percentageBefore") {
				let descuento =
					parseFloat(subtotal) * (parseFloat(invoice.discount) / 100.0);
				taxes = subtotal * taxPercentaje;
				total = subtotal - descuento + taxes;
				setDiscountAmount(descuento);
			} else if (invoice.discountType === "amountAfter") {
				taxes = subtotal * taxPercentaje;
				total = subtotal + taxes;
				let descuento = invoice.discount;
				total -= descuento;
				setDiscountAmount(descuento);
			} else if (invoice.discountType === "amountBefore") {
				let descuento = invoice.discount;
				total = subtotal - descuento;
				taxes = total * taxPercentaje;
				total += taxes;
				setDiscountAmount(descuento);
			}
		} else {
			taxes = taxPercentaje * subtotal;
			total = subtotal + taxes;
			setDiscountAmount(0);
		}
		setTaxAmount(taxes);

		let balance = 0;
		if (job.pendingBalance || job.pendingBalance === 0) {
			balance = job.pendingBalance;
		} else {
			balance = total;
		}
		setTotal(total);
		setBalance(balance);

		const anticipo = job.deposit || deposit;
		setDeposit(anticipo);
	};

	const onChangePaymentType = (selectedOption) => {
		setPaymentType(selectedOption);
		form.setFieldValue("reference", undefined);
		form.setFieldValue("transactionNumber", undefined);
	};

	const Header = () => (
		<div>
			<h4>
				Job: {job.number}, Invoice: {invoice.invoiceNumber}
			</h4>
			<table>
				<tbody>
					<tr>
						<td>Tax</td>
						<td>
							<TaxPicker action={() => {}} value={invoiceTax} disabled={true} />
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Fuel Surcharge</td>
						<td>
							<input
								type="text"
								name="fuelSurcharge"
								className="form-control"
								value={toCurrency(fuelSurcharge, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Price</td>
						<td>
							<input
								type="text"
								name="unitPrice"
								className="form-control"
								value={toCurrency(unitPrice, 2)}
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Delivery Fee</td>
						<td>
							<input
								type="text"
								name="deliveryFee"
								className="form-control"
								value={toCurrency(deliveryFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Material</td>
						<td>
							<input
								type="text"
								value={toCurrency(material, 2)}
								className="form-control"
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Miscelaneos</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="miscelaneosFee"
								value={toCurrency(miscelaneosFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Subtotal</td>
						<td>
							<input
								type="text"
								value={toCurrency(subtotal, 2)}
								className="form-control"
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Color</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="colorTicket"
								value={toCurrency(colorTicket, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Discount</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="discount"
								defaultValue={toCurrency(discountAmount, 2)}
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Size</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="sizeBags"
								value={toCurrency(sizeBags, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Tax Amount</td>
						<td>
							<input
								type="text"
								value={toCurrency(taxAmount, 2)}
								className="form-control"
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Fiber</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="fiberBags"
								value={toCurrency(fiberBags, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Job Total</td>
						<td>
							<input
								type="text"
								value={toCurrency(total, 2)}
								className="form-control"
								readOnly
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>

						<td>Credit Card Payment</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="creditCardFee"
								value={toCurrency(creditCardFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Payments</td>
						<td>
							<input
								type="text"
								readOnly
								className="form-control"
								value={toCurrency(sumPayment, 2)}
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Energy Consumption</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="energyConsumptionFee"
								value={toCurrency(energyConsumptionFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td>Balance</td>
						<td>
							<input
								type="text"
								readOnly
								className="form-control"
								value={toCurrency(balance, 2)}
								style={{ textAlign: "right", fontWeight: "bold" }}
							/>
						</td>
						<td style={{ width: "30%" }}></td>
						<td>Light Vehicle Surcharge</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="lightSurchargeFee"
								defaultValue={toCurrency(lightSurchargeFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Time Surcharge</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="timeSurchargeFee"
								value={toCurrency(timeSurchargeFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Ice Surcharge</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="iceSurchargeFee"
								value={toCurrency(iceSurchargeFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Plant Stand-By</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="plantStandByFee"
								value={toCurrency(plantStandByFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Environmental Charge Per Load</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="environmentalChargePerLoadFee"
								value={toCurrency(environmentalChargePerLoadFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Ready Mix Truck Rental Service</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="readyMixTruckRentalServiceFee"
								value={toCurrency(readyMixTruckRentalServiceFee, 2)}
								readOnly
							/>
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td style={{ width: "30%" }}></td>
						<td>Ready Mix Driver</td>
						<td>
							<input
								type="text"
								className="form-control"
								name="readyMixDriverFee"
								value={toCurrency(readyMixDriverFee, 2)}
								readOnly
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);

	const onSubmitPayment = async (values) => {
		try {
			setLoadingTable(true);
			const url = api + "/customerpaymentnumber";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const { data: customerNumberData } = await axios.get(url);

			if (customerNumberData.customerPaymentNumber === null) {
				form.resetFields();
				setLoadingTable(false);
				return;
			}

			const formData = {
				amount: values.amount,
				type: values.paymentType,
				reference: values.reference,
				at: dayjs(values.date).toDate(),
				comments: values.comments,
				transactionNumber: values.transactionNumber,
				paymentNumber: customerNumberData.customerPaymentNumber,
				job: job._id,
				createdBy: localStorage.getItem("userId"),
			};

			await addPayment(formData);
			form.resetFields();
			setInitialValues({
				date: dayjs(),
			});
			updateBalance(formData);
		} catch (error) {
			setLoadingTable(false);
			openNotification("error", "Error", "Error submitting payment");
			console.error("Error submitting payment:", error);
		}
	};

	const onFinishAddPayment = (values) => {
		onSubmitPayment(values);
	};

	const RenderForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinishAddPayment}
			>
				<Row gutter={16}>
					<Col span={6}>
						<Form.Item
							label="Payment Type"
							name="paymentType"
							rules={[
								{
									required: true,
									message: "Payment Type required",
								},
							]}
						>
							<Select
								size="large"
								options={optionsPaymentType}
								style={{ width: "100%" }}
								onChange={onChangePaymentType}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item
							label="Amount"
							name="amount"
							rules={[
								{
									required: true,
									message: "Amount required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item
							label="Date"
							name="date"
							rules={[
								{
									required: true,
									message: "Date required",
								},
							]}
						>
							<DatePicker
								size="large"
								format="MM/DD/YYYY"
								style={{ width: "100%" }}
								allowClear={false}
							/>
						</Form.Item>
					</Col>

					{(paymentType === "Card" || paymentType === "Check") && (
						<Col span={6}>
							<Form.Item label="Reference" name="reference">
								<Input size="large" />
							</Form.Item>
						</Col>
					)}
					{paymentType === "Wire" && (
						<Col span={6}>
							<Form.Item
								label="Transaction Number"
								name="transactionNumber"
								rules={[
									{
										required: true,
										message: "Transaction Number required",
									},
								]}
							>
								<Input size="large" />
							</Form.Item>
						</Col>
					)}
					<Col span={24}>
						<Form.Item label="Comments" name="comments">
							<Input.TextArea size="large" />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Button
							type="primary"
							htmlType="submit"
							size="large"
							disabled={loadingTable || balance === 0}
						>
							Add Payment
						</Button>
						&nbsp;
						<Button
							type="default"
							htmlType="button"
							size="large"
							onClick={pcb}
							disabled={loadingTable || balance === 0}
						>
							Send changes to Daily
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	const onDeletePayment = async (record) => {
		try {
			setLoadingTable(true);
			await deletePayment(record.id);

			updateBalanceOnDelete(record);
		} catch (error) {
			setLoadingTable(false);
			openNotification("error", "Error", "Error deleting payment");
			console.error("Error deleting payment:", error);
		}
	};

	const columns = [
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Payment Number",
			dataIndex: "paymentNumber",
			key: "paymentNumber",
			render: (value) => <Text strong>{value}</Text>,
		},
		{
			title: "Amount",
			dataIndex: "amount",
			key: "amount",
			render: (value) => (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix="$"
				/>
			),
		},
		{
			title: "Reference",
			dataIndex: "reference",
			key: "reference",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Transaction Number",
			dataIndex: "transactionNumber",
			key: "transactionNumber",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Comments",
			dataIndex: "comments",
			key: "comments",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "User",
			dataIndex: "user",
			key: "user",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => (
				<Button
					icon={<DeleteOutlined />}
					size="large"
					type="primary"
					danger
					onClick={() => onDeletePayment(record)}
				>
					Delete
				</Button>
			),
		},
	];

	const RenderTable = () => {
		return (
			<CustomTable
				columns={columns}
				data={payments}
				isScroll={true}
				loading={loadingTable}
			/>
		);
	};

	return (
		<div>
			<Flex vertical gap={20}>
				<Header />
				<RenderTable />
				<RenderForm />
			</Flex>
			{contextHolder}
		</div>
	);
};

export default PaymentJob2;
